import * as Actions from '../actions/rooms.actions';

const initialState = [];

const rooms = (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_ROOMS: {
      return action.payload;
    }
    case Actions.ADD_ROOMS: {
      return [...state, action.payload];
    }
    case Actions.UPDATE_ROOMS:
    case Actions.GET_ROOM: {
      const index = state.findIndex((room) => room.id === action.payload.id);
      const newState = state;
      newState[index > -1 ? index : state.length] = action.payload;
      return [...newState];
    }
    case Actions.REMOVE_ROOMS: {
      return state.filter((obj) => obj.id !== action.payload.id);
    }
    default:
      return state;
  }
};

export default rooms;
